/* eslint-disable */
// TODO: Check for correct typing
export interface Action {
  type?: string;
  link?: Link;
  text?: string;
  iconLink?: string;
  bookingActionType?: string;
}

export interface Address {
  country?: string;
  address?: string;
  city?: string;
  countryCode?: string;
  postcode?: string;
  state?: string;
}

export interface AvalonErrorBody {
  requestUrl?: string;
  message?: string;
}

export interface AvalonErrorResponse {
  error?: AvalonErrorBody;
}

export interface AvalonStrings {
  landingPage: LandingPageStrings;
  filterPage: FilterPageStrings;
  searchBookingPage: SearchBookingsString;
  checkInAction: CheckInAction;
}

export interface OrdersPageStrings {
  activeEmptyStatePrimaryText: string;
  activeEmptyStateSecondaryText: string;
  activeEmptyStateSecondaryLinkText: string;
  pastEmptyStatePrimaryText: string;
  pastEmptyStateSecondaryText: string;
  pastEmptyStateSecondaryLinkText: string;
  activeNotificationText: string;
  activeNotificationCta: string;
  pastNotificationText: string;
  pastNotificationCta: string;
  order: OrderStrings;
}

export interface LandingPageStrings {
  title: string;
  tabActive: string;
  tabPast: string;
  ordersPage: OrdersPageStrings;
  actionErrorMessage: string;
}

export interface FilterPageStrings {
  activeFilterPageTitle: string;
  pastFilterPageTitle: string;
  filterResetCTA: string;
  lobFilterTitle: string;
  dateFilterTitle: string;
  apply: string;
  lobFilterStrings: LobFilterStrings;
  dateFilterStrings: DateFilterStrings;
}

export interface LobFilterStrings {
  lobFilterTextAll: string;
  lobFilterTextFlights: string;
  lobFilterTextHotels: string;
  lobFilterTextSnap: string;
  lobFilterTextRide: string;
  lobFilterTextGift: string;
  lobFilterTextShop: string;
}

export interface DateFilterStrings {
  dateFilterTextWithin: string;
  dateFilterTextMoreThan: string;
  dateFilterTextLast: string;
  dateFilterTextAll: string;
  dateFilterTextDay: string;
  dateFilterTextDayPlural: string;
  dateFilterTextWeek: string;
  dateFilterTextWeekPlural: string;
  dateFilterTextMonth: string;
  dateFilterTextMonthPlural: string;
  dateFilterTextYear: string;
  dateFilterTextYearPlural: string;
  dateFilterTextRecent: string;
  dateFilterTextPastPurchases: string;
  dateFilterTextActivePurchases: string;
}

export interface OrderStrings {
  flightStatus: string;
  status: string;
  flightOrderDatePre: string;
  flightInsuranceLabel: string;
}

export interface SearchBookingsString {
  title: string;
  bookingNumberFieldLabel: string;
  nameFieldLabel: string;
  departCityFieldLabel: string;
  emailFieldLabel: string;
  btnText: string;
  incorrectInfoErrorMessage: string;
  infoHeading: string;
  infoText1: string;
  infoText2: string;
  textFieldEmptyMessage: string;
}

export interface CheckInAction {
  errorMessageNoBarCode: string;
  errorMessageConfirmationDeeplink: string;
  errorMessageDeeplink: string;
  errorMessageSomethingWentWrong: string;
  errorMessageFlightDeparted: string;
  errorMessageFlightCancelled: string;
  errorMessageCustomerSupport: string;
  errorMessageConnectionDefault: string;
  errorMessageNetworkConnection: string;
  errorMessageBookingNotConfirmed: string;
  errorMessageUnpaidBalance: string;
  errorMessageStandbyBooking: string;
  errorMessageFerryBooking: string;
  errorMessageSystem: string;
  errorMessageServer: string;
}

export interface Avatar {
  name?: string;
  status?: string;
  url?: string;
}

export interface BoardingPassDetailsRequestBody {
  pnr?: string;
  journeyType?: string;
  lastName?: string;
  passengerNumber?: string;
  googleWalletAvailable?: string;
  validBaggageSSRList?: string[];
  contactless: string;
}

export interface BoardingPassData {
  journeyBPList: JourneyBoardingPassModel[];
}

export interface JourneyBoardingPassModel {
  flown?: boolean;
  pnr: string;
  segmentBPList: SegmentBoardingPassDetail[];
  googleWalletToken?: string;
}

export interface SegmentBoardingPassDetail {
  ArrivalStation?: string;
  ArrivalStationAirport?: string;
  ArrivalStationFullName?: string;
  ArrivalTerminal?: string;
  Barcode?: string;
  BarcodeBase64?: string;
  BarcodeText?: string;
  BoardingDateTime?: string;
  BoardingDetails?: BoardingDetail[];
  BoardingPassPdfUrl?: BoardingPassPdfUrl[];
  BordingPassType?: string;
  CarrierCode?: string;
  ContactLessBarcode?: ContactLessBarcode[];
  ContactLessQRCode?: ContactLessQRCode[];
  DepartureStation?: string;
  DepartureStationAirport?: string;
  DepartureStationFullName?: string;
  DepartureTerminal?: string;
  EBPSSRCode?: string[][];
  ebpAllowed?: boolean;
  FlightNumber?: string;
  ImmigrationSeal?: string;
  IsIslandTransfer?: boolean;
  JourneyKey?: string;
  PassengerName?: PassengerName[];
  paxTypeList?: string[];
  pkPass?: string;
  ProductClass?: string;
  STA?: string;
  STD?: string;
  etd?: string;
  eta?: string;
  Seats?: Seat[];
  SecuritySeal?: string;
  SegmentKey?: string;
  BaggageDropCloseTime?: string;
  GateCloseTime?: string;
  FacesStatus?: FacesStatus[];
}

export interface BoardingDetail {
  BoardingGate?: string;
  BoardingZone?: string;
  PassengerID?: string;
  passengerNameCounterCheck?: boolean;
}

export interface ContactLessBarcode {
  ImageBase64?: string;
  PassengerID?: string;
  URL?: string;
}

export interface ContactLessQRCode {
  ImageBase64?: string;
  PassengerID?: string;
  URL?: string;
}

export interface BoardingPassPdfUrl {
  PassengerID?: string;
  URL?: string;
}

export interface PassengerName {
  documentCheckRequired?: boolean;
  firstName?: string;
  fullName?: string;
  lastName?: string;
  passengerID?: string;
}

export interface Seat {
  BoardingSequence?: string;
  passengerID?: string;
  PassengerNumber?: string;
  seatDesignator?: string;
}

export interface FacesStatus {
  Status?: string;
  PassengerID?: string;
}

export interface BookingDetails {
  title?: string;
  bookingAt?: string;
  bookingType?: string;
  paymentStatus?: string;
  deliveryType?: string;
  validTill?: string;
  validTillUnix?: string;
  imageUrlGcp?: string;
  productId?: string;
  imageUrl?: string;
  language?: string;
  validFrom?: string;
  validFromUnix?: string;
  whereToRedeem?: string;
  validityDays?: number;
}

export interface HotelBookingSearchRequest {
  email: string;
  lastName: string;
  orderNumber: string;
}

export interface OrdersItem {
  orderKey?: string;
}

export interface CheckInBookingValidationRequest {
  recordLocator?: string;
  lastName?: string;
  isUpdationRequired?: string;
}

export class CheckinBookingData {
  bookingId?: string;
  journeys?: CheckinJourney[];
  passengers?: PassengerX[];
  pnr?: string;
  currencyCode?: string;
  isFraud?: boolean;
  token?: string;

  hasAnyMemberAllowedCheckinWithSsr(): boolean {
    if (!this.journeys) return true;
    for (const journey of this.journeys) {
      for (const segment of journey.segments ?? []) {
        for (const passenger of segment.passengers ?? []) {
          if (passenger.hasBlockedSSR === false) {
            return true;
          }
        }
      }
    }
    return false;
  }

  hasAllJourneyFlightFlown(): boolean {
    return (
      this.journeys?.every(
        (journey) => journey.journeyCheckinStatus?.flightFlown === true,
      ) ?? false
    );
  }

  hasAllJourneyCanceled(): boolean {
    return (
      this.journeys?.every(
        (journey) => journey.journeyCheckinStatus?.isCanceled === true,
      ) ?? false
    );
  }
}

export interface CheckinJourney {
  segments?: CheckinSegment[];
  departureAirportCode?: string;
  arrivalAirportCode?: string;
  international?: boolean;
  journeyCheckinStatus?: JourneyCheckinStatus;
  actualDepartureTime?: string;
  type?: string;
  hasBlockedStation: boolean;
}

export interface CheckinPassenger {
  checkinStatus?: string;
  id?: string;
  hasBlockedSSR?: boolean;
}

export interface CheckinSegment {
  passengers?: CheckinPassenger[];
  segmentInfo?: string;
  legs?: SegmentLeg[];
}

export interface SegmentLeg {
  ETA?: string;
  ETD?: string;
  sta?: string;
  std?: string;
}

export interface PassengerX {
  dob?: string;
  firstName?: string;
  lastName?: string;
  passengerNumber?: string;
  infant?: PassengerX;
}

export interface JourneyCheckinStatus {
  flightFlown?: boolean;
  isCanceled?: boolean;
  daysOrHours?: string;
  status?: boolean;
  upcoming?: boolean;
  timeLeft: number;
}

export interface CheckInPWARequest {
  culture_code?: string;
  currency?: string;
  pnr?: string;
  lastname?: string;
  bookingdata?: any; // JsonObject
  countryCode?: string;
  params?: CheckInPWAParamsRequest;
}

export interface CheckInPWAParamsRequest {
  refreshToken?: string;
  userId?: string;
  checkinWithFaces?: boolean;
  passportScanner?: boolean;
  mobileDetails?: MobileDetails;
  selectedJourneyIndex?: number;
  hasInitiatedEnrolment: boolean;
  enrolFaces?: CheckFacesAttempts;
  emailOfActor?: string;
}

export interface CheckFacesAttempts {
  firstName?: string;
  lastName?: string;
}

export interface MobileDetails {
  ga_client_id?: string;
  device_id?: string;
  os?: string;
  os_version?: string;
  device_brand?: string;
  device_model?: string;
  fcm_token?: string;
  app_version?: string;
  member_id?: string;
}

export interface CheckInDeeplinkUrl {
  url: string;
}

export interface CheckinBookingDataResult {
  data?: CheckinBookingData;
  jsonObj?: any; // JsonObject
  errorMsg?: string;
  errorCode?: string;
}

export interface SsrKeyData {
  ssr_data: SsrData[];
}

export interface SsrData {
  source: string;
  ssrgroup: string;
  ssrlist: string[];
}

export interface CheckinDeeplinkResponse {
  url?: string;
  errorCode?: string;
  errorMessage?: string;
  isCheckInConfirmation?: boolean;
}

export interface Customer {
  ssoUserId?: string;
  navitaireId?: string;
  loyaltyId?: string;
  email?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  fullName?: string;
  dialingCode?: string;
  phoneNo?: string;
  passengerNumber?: string;
}

export interface Destination {
  name?: string;
  address?: string;
  packageInfo?: PackageInfo;
  recipientInfo?: RecipientInfo;
  arrived?: boolean;
}

export interface Detail {
  label?: string;
  value?: string;
  type?: string;
}

export interface Driver {
  fullName?: string;
  vehicleInfo?: string;
}

export interface DropOff {
  name?: string;
  address?: string;
  completed?: boolean;
  arrived?: boolean;
  estimatedDropOffTime?: EstimatedTime;
}

export interface EstimateDelivery {
  maxBy?: string;
  minBy?: string;
}

export interface EstimatedTime {
  max?: string;
  min?: string;
}

export class Filter {
  lob?: string;
  dateId?: string;
  isSelected: boolean;
  countries?: string[];

  constructor(
    lob?: string,
    dateId?: string,
    isSelected: boolean = false,
    countries?: string[],
  ) {
    this.lob = lob;
    this.dateId = dateId;
    this.isSelected = isSelected;
    this.countries = countries;
  }

  private today(): Date {
    return new Date();
  }

  private dateAfter(amount: number, dateType: string): Date | null {
    const d = new Date(this.today());
    switch (dateType.toLowerCase()) {
      case 'days':
        d.setDate(d.getDate() + amount);
        return d;
      case 'months':
        d.setMonth(d.getMonth() + amount);
        return d;
      case 'years':
        d.setFullYear(d.getFullYear() + amount);
        return d;
      default:
        return null;
    }
  }

  private dateBeforeToday(amount: number, dateType: string): Date | null {
    return this.dateAfter(-amount, dateType);
  }

  dateRange(
    fulfilmentTime: FulfillmentTime,
  ): { startDate?: string; endDate?: string } | undefined {
    const id = this.dateId;
    if (!id || id === 'all') return undefined;
    const parts = id?.split('_');
    const type = parts?.[0];
    const amount = parts?.[1] ? parseInt(parts[1], 10) : undefined;
    const dateType = parts?.[2];
    if (amount === undefined || dateType === undefined) {
      return { startDate: undefined, endDate: undefined };
    }

    switch (this.dateConstraintFrom(type)) {
      // new date constraint
      case DateConstraint.WITHIN:
        if (fulfilmentTime === FulfillmentTime.past) {
          // Past → - amont days to today
          return {
            startDate: this.dateBeforeToday(amount, dateType)
              ?.toISOString()
              .split('T')[0],
            endDate: new Date().toISOString().split('T')[0],
          };
        }

        // Active → today to + amount days
        return {
          startDate: new Date().toISOString().split('T')[0],
          endDate: this.dateAfter(amount, dateType)
            ?.toISOString()
            .split('T')[0],
        };
      //old date constraint
      // case DateConstraint.WITHIN:
      //   return {
      //     startDate: this.today().toISOString().split('T')[0],
      //     endDate:
      //       amount !== undefined && dateType !== undefined
      //         ? this.dateAfter(amount, dateType)?.toISOString().split('T')[0]
      //         : undefined,
      //   };

      case DateConstraint.MORE_THAN:
        return {
          startDate:
            amount !== undefined && dateType !== undefined
              ? this.dateAfter(amount, dateType)?.toISOString().split('T')[0]
              : undefined,
          endDate: undefined,
        };

      case DateConstraint.UP_TO:
        return {
          startDate:
            amount !== undefined && dateType !== undefined
              ? this.dateBeforeToday(amount, dateType)
                  ?.toISOString()
                  .split('T')[0]
              : undefined,
          endDate: this.today().toISOString().split('T')[0],
        };

      case DateConstraint.RECENT:
        return undefined;

      default:
        return { startDate: undefined, endDate: undefined };
    }
  }

  private dateConstraintFrom(str?: string | null): DateConstraint | null {
    if (!str) return null;

    switch (str.toLowerCase()) {
      case 'morethan':
        return DateConstraint.MORE_THAN;
      case 'upto':
        return DateConstraint.UP_TO;
      default:
        try {
          return (
            DateConstraint[str.toUpperCase() as keyof typeof DateConstraint] ??
            null
          );
        } catch {
          return null;
        }
    }
  }
}

export enum DateConstraint {
  WITHIN = 'WITHIN',
  MORE_THAN = 'MORE_THAN',
  UP_TO = 'UP_TO',
  RECENT = 'RECENT',
}

export enum DateAmount {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export interface FilterSettings {
  lobFilters?: Filter[];
  dateFilters?: Filter[];
}

export interface Filters {
  activeFilters?: FilterSettings;
  pastFilters?: FilterSettings;
}

export interface FlightOrderItem {
  segment?: Segment;
  journey?: Journey;
}

export interface From {
  name?: string;
  address?: string;
  arrived?: boolean;
  estimatedPickupTime?: EstimatedTime;
}

export interface GroupInfo {
  name?: string;
  type?: string;
  tagline?: string;
  avatars?: Avatar;
}

export interface Item {
  currency?: string;
  name?: string;
  totalAmount?: number;
}

export interface UpcomingFlightBookingDetails {
  PNR: string;
  Culture: string;
}

export interface ItineraryFlightModel {
  'encrypted-string'?: string;
}

export interface Journey {
  segments?: Segment[];
  passengers?: Passenger[];
  journeyType?: string;
  journeyIndex?: number;
}

export interface Link {
  mobile?: string;
  web?: string;
}

export interface Metadata {
  provider?: Provider;
  bookingPath?: string;
}

export interface NumberOfGuest {
  child?: number;
  adult?: number;
}

export interface Order {
  bookingId: string;
  type: OrderType;
  refId?: string;
  status?: string;
  statusInfo?: StatusInfo;
  metadata?: Metadata;
  customer?: Customer;
  fulfilmentDate?: string;
  fulfilmentTime?: FulfillmentTime;
  isUpcoming?: boolean;
  data?: OrderData;
  totalAmount?: number;
  currency?: string;
  sortingTimestamp?: string;
  paymentStatus?: string;
  message?: string;
  isLoading?: boolean;
}

export enum OrderType {
  flights = 'flights',
  hotel = 'hotel',
  snap = 'snap',
  food = 'food',
  shop = 'shop',
  ride = 'ride',
  gift = 'gift',
  movetix = 'movetix',
}

export enum FulfillmentTime {
  all = 'all',
  past = 'past',
  active = 'active',
  upcoming = 'upcoming',
}

export interface OrderData {
  totalAmount?: number;
  balanceDue?: number;
  currency?: string;
  orderDate?: string;
  orderDateUnix?: string;
  orderItems?: OrderItem[];
  journeys?: Journey[];
  flightOrderItem?: FlightOrderItem;
  type?: string;
  orderDateLocal?: string;
  bookingAgent?: string;
  displayConfig?: DisplayConfig;
}

export interface OrderItem {
  name?: string;
  status?: string;
  statusInfo?: StatusInfo;
  bookingReference?: string;
  totalAmount?: number;
  groupInfo?: GroupInfo;
  from?: From;
  dropoff?: DropOff[];
  bookingDetails?: BookingDetails;
  driver?: Driver;
  pickupInfo?: PickupInfo;
  destinations?: Destination[];
  currency?: string;
  deliveredAt?: string;
  deliveryFee?: number;
  estimatedDelivery?: EstimateDelivery;
  supplier?: Supplier;
  items?: Item[];
  address?: Address;
  actions?: Action[];
  hotelCheckinTime?: string;
  hotelCheckoutTime?: string;
  hotelTimezone?: string;
  numberOfRooms?: string;
  numberOfGuest?: NumberOfGuest;
  checkInDate?: string;
  checkInDateUnix?: string;
  checkOutDate?: string;
  checkOutDateUnix?: string;
  vehicleInfo?: VehicleInfo;
  detail1?: Detail;
  detail2?: Detail;
  fulfilmentTime?: string;
  sortingTimestamp?: string;
}

export interface OrderSearchResponse {
  message?: string;
  result?: PageResponse;
}

export interface OrdersHistory {
  upcomingOrders?: OrderItem[];
  pastOrders?: OrderItem[];
}

export interface OrderStatusInfo {
  generic_status?: StatusInfo[];
  lob_status?: LobStatus[];
}

export interface LobStatus {
  lob?: string;
  status?: StatusInfo[];
}

export enum StatusInfoLabel {
  TonedSuccess = 'TonedSuccess',
  TonedMedium = 'TonedMedium',
  TonedHigh = 'TonedHigh',
  TonedLow = 'TonedLow',
  Filled = 'Filled',
}

export interface StatusInfo {
  order_status?: string;
  locale?: { [key: string]: string };
  bg_color?: string;
  text_color?: string;
  label?: StatusInfoLabel;
}

export interface PackageInfo {
  consignmentValue?: string;
  length?: string;
  width?: string;
  weight?: string;
  commodity_currency_id?: string;
  type?: string;
  height?: string;
}

export interface PageResponse {
  page?: number;
  limit?: number;
  total?: number;
  data?: Order[];
}

export interface Passenger {
  name?: string;
  type?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
}

export enum PassengerType {
  ADULT = 'ADULT',
  ADT = 'ADT',
  ADTD = 'ADTD',
  ADTI = 'ADTI',
  ADTT = 'ADTT',
  BBG = 'BBG',
  ESO = 'ESO',
  EXT = 'EXT',
  KAZ = 'KAZ',
  KLN = 'KLN',
  MIL = 'MIL',
  STD = 'STD',
  PWD = 'PWD',
  SCP = 'SCP',
  MLN = 'MLN',
  OFW = 'OFW',
  CLN = 'CLN',
  CLC = 'CLC',
  YPTA = 'YPTA',
  CHILD = 'CHILD',
  CHD = 'CHD',
  MLC = 'MLC',
  INFANT = 'INFANT',
  INFT = 'INFT',
  INF = 'INF',
  NULL = 'NULL',
}

export interface PickupInfo {
  name?: string;
  address?: string;
  senderInfo?: SenderInfo;
  arrived?: boolean;
}

export interface Provider {
  name?: string;
  agent?: string;
}

export interface RecipientInfo {
  phoneCountryCode?: string;
  fullName?: string;
  remarks?: string;
  email?: string;
  phoneNo?: string;
}

export interface Segment {
  actionStatusCode?: string;
  carrierCode?: string;
  statusInfo?: StatusInfo;
  checkInStatus?: string[];
  departureDateLocal?: string;
  departureDateLocalUnix?: number;
  departureDate?: string;
  departureDateTimezone?: string;
  departureDateUnix?: number;
  destination?: string;
  destinationStation?: Station;
  flightNumber?: string;
  origin?: string;
  originStation?: Station;
  productClass?: string;
  arrivalDateLocal?: string;
  arrivalDate?: string;
  arrivalDateTimezone?: string;
  segmentStatus?: string;
  actions?: Action[];
  detail1?: Detail;
  detail2?: Detail;
  fulfilmentTime?: string;
  segmentIndex?: number;
  sortingTimestamp?: string;
  isInsuranceTaken?: boolean;
  recordLocator?: string;
  lastName?: string;
  selectedJourneyType?: string;
  selectedPassenger?: string[];
  journeyType: number;
  journeyIndex?: number;
  bookingType: string;
}

export interface SenderInfo {
  phoneCountryCode?: string;
  fullName?: string;
  email?: string;
  phoneNo?: string;
}

export interface Station {
  StationCode?: string;
  StationName?: string;
  CountryCode?: string;
  CountryName?: string;
  StationType?: string;
  AirportName?: string;
  TimeZone?: string;
  AlternativeName?: string;
  Lat?: string;
  Long?: string;
  PinYin?: string;
  CityCode?: string;
  CityName?: string;
}

export interface Supplier {
  name?: string;
}

export interface Trip {
  tripId?: string;
  type?: TripType;
  tripName?: string;
  image?: string;
  startDate?: string;
  endDate?: string;
  startDateUnix?: string;
  endDateUnix?: string;
  origin?: string;
  originStation?: Station;
  destination?: string;
  destinationStation?: Station;
  status?: string;
  events?: TripEvent[];
  actions?: Action[];
}

export enum TripType {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export interface TripEvent {
  type?: string;
  destination?: string;
  destinationStation?: Station;
  name?: string;
  origin?: string;
  originStation?: Station;
  bookingId?: string;
  refId?: string;
  flightNumber?: string;
  departureDate?: string;
  departureDateUnix?: string;
  arrivalDate?: string;
  arrivalDateUnix?: string;
  checkOutDate?: string;
  checkOutDateUnix?: string;
  checkInDate?: string;
  checkInDateUnix?: string;
  status?: string;
  journeyType?: string;
  lowFare?: string;
  priceIndicator?: string;
  actions?: Action[];
}

export interface TripsResponse {
  statusCode?: number;
  message?: string;
  data?: Trip;
}

export interface VehicleInfo {
  bodyType?: string;
  color?: string;
  country?: string;
  manufactureYear?: string;
  manufacturer?: string;
  model?: string;
  registrationNo?: string;
}

export enum StationTypeFilter {
  ALL = 'ALL',
  AIRPORT = 'A',
  CITY = 'C',
}

export interface DisplayConfig {
  activeTime?: string;
}
